import styled from 'styled-components';

import { Select } from '@dreryk/react-components';

export const StyledNfzDepartmentSelect = styled(Select)`
   min-width: 210px;
` as typeof Select;
